// extracted by mini-css-extract-plugin
export default {"heading":"Ut-z","createAccount":"Vt-z","disabled":"Wt-z","copy":"Xt-z","terms":"Yt-z"};